import { render, staticRenderFns } from "./ActionsCollaborateur.vue?vue&type=template&id=cdf21e42&"
import script from "./ActionsCollaborateur.vue?vue&type=script&lang=js&"
export * from "./ActionsCollaborateur.vue?vue&type=script&lang=js&"
import style0 from "./ActionsCollaborateur.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports